;(function() {
  // Define relevant parts of modal
  const modalWrapper = document.getElementById('large-modal-wrapper');
  if (!modalWrapper) return;  
  const modalBody = modalWrapper.querySelector('.large-modal-body');
  const closeBtn = modalWrapper.querySelector('#large-modal-close-x');
  const closeTxt = modalWrapper.querySelector('#large-modal-close-text');

  //Pass variable HTML content into modal container as a fn param
  function openModal(content) {
    modalBody.innerHTML = content;
    modalWrapper.setAttribute('aria-hidden', 'false');
    modalWrapper.classList.add('open');
    closeBtn.focus();
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modalWrapper.setAttribute('aria-hidden', 'true');
    modalWrapper.classList.remove('open');
    modalBody.innerHTML = '';
    document.body.style.overflow = '';
  }

  //Define the above funcs globally to get around scope issues
  window.openModal = openModal;
  window.closeModal = closeModal;
  
  // When clicking modal closing elems (X btn, "Back to Page" txt, area outside modal), call closeModal
  closeBtn.addEventListener('click', closeModal);
  closeTxt.addEventListener('click', closeModal);
  modalWrapper.addEventListener('click', e => {
    if (e.target === modalWrapper) closeModal();
  });
  
})();